import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseService } from '../../services/base.service';
import { NotificationService } from '../../services/notifications.service';
import { combineLatest } from 'rxjs';

@Component({
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotificationPopupComponent {
  notification!: any;

  constructor(
    public dialogRef: MatDialogRef<NotificationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly baseService: BaseService,
    private readonly notificationService: NotificationService,
  ) {
    this.notification = data?.data?.notification;
  }

  save() {
    this.dialogRef.close(true);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  readNot() {
    this.notificationService.readNotification(this.notification.id).subscribe(() => {
      this.save();
      combineLatest([
        this.notificationService.getCountNotification(),
        this.notificationService.getLastNotification(),
      ]).subscribe();
    });
  }
}
